import React from "react";
import DycRouteSettingConfig from "./DycRouteSettingConfig";
import RoutersList from "./RouterConfig";

const AppRoutes = () => {
  return (
    <>
      {RoutersList.map((config, index) => (
        <DycRouteSettingConfig
          key={index}
          routeLayout={config.RouteLayout}
          protectRoute={config.ProtectRoute}
          routeList={config.RouteList}
        />
      ))}
    </>
  );
};

export default AppRoutes;
